import { combineReducers } from 'redux';
import apiStatus from './api-status-reducer';
import registerForm from './register-form-reducer';
import userAddressReducer from './user-address-reducer';
import upgradeAccountForm from './upgrade-account-reducer';
import basket from './basket-reducer';
import signInForm from './sign-in-form-reducer';
import forgotPasswordForm from './forgot-password-form-reducer';
import resetPasswordForm from './reset-password-form-reducer';
import userAccount from './user-account-reducer';
import itemListForm from './item-list-form-reducer';
import verifyEmailForm from './verify-email-form-reducer';

const rootReducer = combineReducers({
    registerForm,
    itemListForm,
    upgradeAccountForm,
    basket,
    userAddressSearchData: userAddressReducer,
    signInForm,
    forgotPasswordForm,
    resetPasswordForm,
    verifyEmailForm,
    userAccount,
    apiStatus,
});

export default rootReducer;
